// @flow
import React, { useMemo } from 'react';
import type { Element } from 'react';
import Head from 'next/head';

import { canonicalConditions } from './utils';

import type { Props, FilterFunction } from './types';

const CanonicalLink = ({ query, pathname }: Props): Element<any> => {
  const canonicalPathname: string = useMemo(() => {
    const urlFilterFunc: FilterFunction = canonicalConditions[(query?.nextRoute)];

    if (urlFilterFunc) {
      return urlFilterFunc(query, pathname);
    }

    return pathname;
  }, [query, pathname]);

  return (
    <Head>
      <link
        rel="canonical"
        key="canonical"
        url={`${process.env.YAPITA_HEALTH_URL || ''}${canonicalPathname}`}
      />
    </Head>
  );
};

export default CanonicalLink;
